import { useMemo } from 'react'
import { motion } from 'framer-motion'
import { standingsAt } from './data'
import { RankDelta, TeamLogo, formatLongDay, formatScore } from './ui'

export default function Standings({ league, date, focusId, hoverId, onHover, onSelect }) {
  const rows = useMemo(() => standingsAt(league, date), [league, date])
  const [min, max] = useMemo(() => {
    const scores = rows.map(r => r.score)
    return [Math.min(0, ...scores), Math.max(...scores, 0.01)]
  }, [rows])

  return (
    <aside className="hv-card hv-standings">
      <header className="hv-card-head">
        <div>
          <h3>Standings</h3>
          <p className="hv-muted hv-small">{formatLongDay(date)}</p>
        </div>
      </header>
      <ol className="hv-standings-list">
        {rows.map(r => {
          const active = r.team.id === focusId
          const hot = r.team.id === hoverId
          return (
            <motion.li
              key={r.team.id}
              layout
              transition={{ type: 'spring', stiffness: 500, damping: 40 }}
              className={`hv-standing ${active ? 'is-active' : ''} ${hot ? 'is-hover' : ''}`}
              style={active ? { '--team': r.team.accent } : undefined}
              onMouseEnter={() => onHover(r.team.id)}
              onMouseLeave={() => onHover(null)}
              onClick={() => onSelect(r.team.id)}
            >
              <span className="hv-standing-rank">{r.rank}</span>
              <TeamLogo team={r.team} size={22} />
              <span className="hv-standing-name">
                {r.team.acronym}
              </span>
              <span className="hv-standing-bar" aria-hidden="true">
                <span style={{ width: `${((r.score - min) / (max - min)) * 100}%` }} />
              </span>
              <span className="hv-standing-score">{formatScore(r.score)}</span>
              <RankDelta value={r.rankDelta} size="sm" />
            </motion.li>
          )
        })}
      </ol>
    </aside>
  )
}
